import { render, staticRenderFns } from "./onSaleDetail.vue?vue&type=template&id=94a4e804&scoped=true&"
import script from "./onSaleDetail.vue?vue&type=script&lang=js&"
export * from "./onSaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a4e804",
  null
  
)

export default component.exports